<template>
    <div class="Air-qita-div">
        <div class="qiTa-list" id="proid">
            <el-row>
                <el-col
                    :span="8"
                    v-for="(item, index) in showList"
                    :key="index"
                >
                    <div class="qita-list-corlor" v-if="index !== 2">
                        <div
                            style="
                                position: relative;
                                width: 100%;
                                height: 100%;
                                object-fit: fill;
                            "
                        >
                        <!-- {{'http://118.89.87.102:8686/' + }} -->
                            <video
                                class="qita-video"
                                controls
                                frameborder="0"
                                preload="metadata"
                                :poster="item.fengMian"
                                :src="
                                    'http://118.89.87.102:8686/' +
                                    item.url
                                "
                                style="width: 100%; background: #000"
                                height="300"
                            ></video>
                        </div>
                    </div>
                    <div class="qita-list-corlor" v-if="index === 2">
                        <div id="aaa" style="position: relative">
                            <img :src="item.url" class="rightPic" />

                            <img
                                :src="item.icon"
                                @click="xiazai(item)"
                                alt=""
                                class="qita-icon"
                            />
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-row class="elrow">
            <el-col :span="8" v-for="(item, index) in showList" :key="index">
                <div class="qiTa-biaoti sms-acc">
                    {{ item.title }}
                </div>
            </el-col>
        </el-row>
        <!--    <div class="qiTadian-jiantou">-->
        <!--      <div style="padding-left: 80px; cursor: pointer" @click="dianji(1)">-->
        <!--        <img class="arrow_pic" src="../assets/images/icon/air-bai-zjt.png" />-->
        <!--      </div>-->
        <!--      <div style="padding-right: 80px; cursor: pointer" @click="dianji(2)">-->
        <!--        <img class="arrow_pic" src="../assets/images/icon/air-bai-yjt.png" />-->
        <!--      </div>-->
        <!--    </div>-->
    </div>
</template>
<script>
import { Loading } from 'element-ui';
export default {
    props: ['list'],
    computed: {
        showList: {
            get() {
                let list = this.list;
                let res = [];
                if (list.length > 2) {
                    res.push(list[this.showIndexs[0]]);
                    res.push(list[this.showIndexs[1]]);
                    res.push(list[this.showIndexs[2]]);
                }
                return res;
            },
        },
    },
    data: () => ({
        showIndexs: [0, 1, 2],
    }),
    methods: {
        xiazai(val) {
            let fileName = '';
            // let reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+).)+([A-Za-z0-9-~\/])+$/
            let loadingInstance = Loading.service({
                target: document.getElementById('aaa'),
                text: '下载中',
            });
            let xhr = new XMLHttpRequest();
            if (val.xiazai === 'RA488') {
                xhr.open(
                    'get',
                    'http://118.89.87.102:8080/jeecg-boot/sys/common/static/RA488 User Manual 使用说明书.pdf',
                    true
                );
                fileName = 'RA488 User Manual 使用说明书.pdf';
            } else if (val.xiazai === 'RA800') {
                xhr.open(
                    'get',
                    'http://118.89.87.102:8080/jeecg-boot/sys/common/static/RA800 User Manual 使用说明书.pdf',
                    true
                );
                fileName = 'RA800 User Manual 使用说明书.pdf';
            }
            xhr.setRequestHeader('Content-Type', `application/pdf`);
            xhr.responseType = 'blob';
            let that = this;
            xhr.onload = function () {
                if (this.status == 200) {
                    //接受二进制文件流
                    var blob = this.response;
                    that.downloadExportFile(blob, fileName, loadingInstance);
                }
            };
            xhr.send();
        },
        downloadExportFile(blob, tagFileName, loadingInstance) {
            let downloadElement = document.createElement('a');
            let href = blob;
            if (typeof blob == 'string') {
                downloadElement.target = '_blank';
            } else {
                href = window.URL.createObjectURL(blob); //创建下载的链接
            }
            downloadElement.href = href;
            downloadElement.download = tagFileName;
            //下载后文件名
            downloadElement.click(); //点击下载
            loadingInstance.close();
            document.body.removeChild(downloadElement); //下载完成移除元素
            if (typeof blob != 'string') {
                window.URL.revokeObjectURL(href); //释放掉blob对象
            }
        },
        dianji(type) {
            if (type === 1) {
                if (this.showIndexs[0] === 0) {
                    this.$message.closeAll();
                    this.$message('已经是第一张啦！', 1);
                    return false;
                }
                this.showIndexs = this.showIndexs.map((element) => element - 1);
            } else {
                if (this.showIndexs[2] + 1 === this.list.length) {
                    this.$message.closeAll();
                    this.$message('已经是第最后一张啦！', 1);
                    return false;
                }
                this.showIndexs = this.showIndexs.map((element) => element + 1);
            }
        },
    },
};
</script>

<style scoped>
/* ------------- mobile端样式(屏幕小于960px) ------------- */
@media only screen and (max-width: 960px) {
    .elrow{
        width: 90% !important;
        margin: auto;
    }
    .qiTa-biaoti {
        font-size: 35px;


    }
    .qita-icon {
        width: 22%;
    }
    .qiTa-list {
        width: 90%;
    }
    .qita-video {
        height: 380px;
    }
    video {
        height: 380px !important;
    }
    .sms-css {
        margin-top: 0.25rem !important;
    }
    .video-pic {
        margin-bottom: 40px;
        height: 380px !important;
    }
}
/* ------------- pc端样式(屏幕大于960px) ------------- */
@media only screen and (min-width: 960px) {
    .elrow{
        /* width: 100% !important; */
            width: 95% !important;
    margin: auto;
    }
    .qiTa-biaoti {
        font-size: 22px;
    }
    .sms-acc{
        /* width: 95% !important; */
    }
    /* .qita-icon{ width: 12%;}
  .qiTa-list { width: 70%;}  */
  .qiTa-list{
      width: 95%;
  }
    video {
        height: 390px;
    }
}
.arrow_pic {
    width: 60px;
    height: 162px;
}
/* 第三部分  产品 */
.Air-qita-div {
    position: relative;
}
.qiTa-list {
    display: flex;
    flex-wrap: wrap;
    
    margin: 0 auto;
}
.qita-list-corlor {
    width: 80%;
    height: 390px;
    margin: 0 auto;
}
.rightPic {
    height: 390px;
    width: 100%;
}
.qita-icon {
    opacity: 0.5;
    position: absolute;
    top: 43%;
    /* left: 40%; */
    margin: auto;
    left: 0;
    right: 0;
}
.qiTadian-jiantou {
    display: flex;
    position: absolute;
    top: 5%;
    width: 100%;
    justify-content: space-between;
}
.qiTa-biaoti {
    width: 100%;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    margin-top: 20px;
    color: #0d1d41;
}
.qiTa-biaoti2 {
    width: 100%;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    margin-top: 20px;
    margin-left: 10%;
    color: #0d1d41;
    font-size: 25px;
}
/*
@media screen and (max-width: 1680px) and (max-height: 1050px){
        iframe{
            height: 300px;

        }
   } */
/* @media screen and (max-height:1050px){
  video{
            height: 300px;


        }

}
@media screen and (max-height: 920px){
 video{
            height: 300px;

        }
} */
</style>



// WEBPACK FOOTER //
// src/components/AirQiTaTransverse.vue